import { useEffect } from 'react';

import {
    fetchPersonalAndSharedContacts,
    fetchSocialIntegrationContacts,
} from 'flow/actions/contact-actions';
import { fetchExtensions } from 'flow/actions/extension-actions';
import { getFavorites } from 'flow/actions/favorites-actions';
import { fetchSocialIntegrationSettings } from 'flow/actions/social-integration-actions';
import { useAppDispatch } from 'flow/hooks/useRedux';

const useFetchContactListData = () => {
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(fetchExtensions('contact', 'live'));
        dispatch(fetchPersonalAndSharedContacts());
        dispatch(fetchSocialIntegrationSettings()).catch(() =>
            console.error('Could not fetch social integration settings'),
        );
        dispatch(fetchSocialIntegrationContacts());
        dispatch(getFavorites());
    }, [dispatch]);
};

export default useFetchContactListData;
